import React from 'react';
import SEO from '../components/SEO';
import Header from "../partials/header/Header";
import Breadcrumb from '../container/Breadcrumb/Breadcrumb';
import AboutFour from '../container/About/AboutFour';
import Video from '../container/Video/Video';
import AboutFive from '../container/About/AboutFive';
import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import CallToActionTwo from '../container/CallToAction/CallToActionTwo';
import Footer from '../container/Footer/Footer';
import ScrollToTop from '../components/ScrollToTop.jsx';
import data1 from '../data/content/aboutFourContent';
import data2 from '../data/content/aboutFiveContent';
import CallToActionThree from "../container/CallToAction/CallToActionThree";
import {useLocation} from "react-router-dom";
import data3 from "../data/SEO/seoData";

const CloudService = () => {
    const currentPage = useLocation();
    let seo_data = data3.filter(dataObj => dataObj.path === currentPage.pathname);
    console.log(currentPage, currentPage.pathname);
    console.log(seo_data,"seo_data");
    return (
        <React.Fragment>
            <SEO title={seo_data[0].metaTitle} URL={seo_data[0].path} description={seo_data[0].metaDesc} />
            <Header />
            <Breadcrumb
                image={seo_data[0].bcEleImage}
                title={seo_data[0].bcEleTitle}
                content="Home"
                contentTwo="Cloud Service"
            />
            <AboutFour
                mainContent={data1.cloud.mainContent}
                subTitle={data1.cloud.subTitle}
                title={data1.cloud.title}
                backgroundImg={data1.cloud.backgroundImg} foregroundImg={data1.cloud.foregroundImg}
            />
            <Video content="Accelerating Business Growth and Scalability" />
            <AboutFive
                mainContent={data2.cloud.mainContent}
                subTitle={data2.cloud.subTitle}
                title={data2.cloud.title}
                backgroundImg={data2.cloud.backgroundImg} foregroundImg={data2.cloud.foregroundImg}
            />
            {/*<TestimonialContainer classOption="bg-primary-blue" />*/}
            <CallToActionThree titleContent="Drive Remarkable Results Today with Tetrahed’s Cloud Expertise" />
            <Footer />
            <ScrollToTop />
        </React.Fragment>
    )
}

export default CloudService;



